module.exports = __webpack_public_path__ + "static/media/algolia.80f31a19.svg";